import Lottie from 'lottie-react';

export type LottieAnimationType = {
  width: string;
  height: string;
  animation: object;
};
export function LottieAnimation({ animation, width, height }:LottieAnimationType) {
  return (
    <Lottie
      animationData={animation}
      width={width}
      height={height}
    />
  );
}

export default LottieAnimation;
